/**
 * The start screen lives in index.html, so it shows before any JavaScript has loaded and
 * while the login is being checked. The app removes it once the first real content is there.
 */
let hidden = false

export function hideSplash(): void {
  if (hidden) return
  const splash = document.getElementById('splash')
  if (!splash) return
  hidden = true
  splash.classList.add('splash--done')
  splash.setAttribute('aria-hidden', 'true')
  const remove = () => splash.remove()
  splash.addEventListener('transitionend', remove, { once: true })
  window.setTimeout(remove, 600) // reduced motion: no transition event
}
